import '../css/Home.css';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const HomePage = () => {
  const smoothScroll = (event) => {
    event.preventDefault();
    const infoSection = document.getElementById('info');
    if (infoSection) {
      infoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const renderSectionModulo = (modulo) => {
    // Adapte esta função conforme sua necessidade
    console.log('Render módulo:', modulo);
  };

  const navigate = useNavigate();

  const handleClick = () => {
    // renderSectionModulo({ id: i + 1, update: false, idModulo: mod.modulo });

    // Depois navega para a página desejada
    navigate('/lesson'); // Caminho da rota
  };

  const [showBg, setShowBg] = useState(false);

  useEffect(() => {
    // Ativa opacidade após montagem do componente
    setTimeout(() => {
      setShowBg(true);
    }, 100); // pequeno atraso para garantir o efeito
  }, []);

  return (
    <>
      <section className="home" style={{ backgroundImage: "url('./img/home/bg_home.png')", position: "relative" }}>
        
        {/* <div className="linha-vertical-animada" /> LINHA ANIMADA */}

        <div className='row n-row'>
          <div className="col-md-6">
            <img className="logo-home-ited" src="./img/home/logo_bayer.svg" alt="" />
          </div>

          {/* <div className={`col-md-6 embacado ${showBg ? 'opacity' : ''}`}> */}
          <div className='col-md-6 embacado opacity'>
            <div className='title-course'>
              <p className='title-first'>Treinamento</p>
              <p className='title'>Procedimento de <br /> Gerenciamento de <br /> Mudanças (MOC)</p>

            <button className='btn-home-inicio'  onClick={handleClick}>
              iniciar            
            </button>  
            </div>  

       
                
            {/* <img
              src="./img/home/logo-senai-branca.svg"
              alt=""
              className="logo-home-2"            
            /> */}
          </div>
        </div>

        {/* <div className="" style={{ width: '100%', bottom: '5px', position: 'absolute', textAlign: 'center' }}>
          <a style={{ marginRight: '0px', cursor: 'pointer' }} onClick={handleClick}>
            <img className='img-scale' src="./img/home/seta-home.svg" style={{ marginTop: '8px' }} alt="Ícone scroll" />
          </a>
        </div> */}
      </section>

      {/* <section id="info" className="home-info" style={{ height: '100vh', backgroundImage: "url('./img/home/bg-home-info.png')" }}>
        <div className="row ajust-row" style={{ height: '100%'}}>
          <div
            className="col-md-8"
            style={{
              backgroundImage: 'url(./img/bg-home-info.png)',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              paddingTop: '40px',
            }}
          >
            <div className="row" style={{ marginLeft: '10%' }}>
              <p className="col-md-12" style={{ textTransform: 'uppercase', marginBottom: 0, paddingLeft: '5px', fontWeight: 500, fontFamily: 'Bree Serif' }}>
                Atualização Docente em
              </p>
              <p className="col-md-3" style={{ backgroundColor: '#2FBCDA', fontSize: '2.7rem', padding: '1px', textAlign: 'center', fontFamily: 'Bree Serif', textTransform: 'uppercase' }}>
                Mecânica
              </p>
              <p className="col-md-8" style={{ borderBottom: '3px solid #2FBCDA', textAlign: 'right', fontSize: '1.3rem', fontWeight: 500, fontFamily: 'Bree Serif', textTransform: 'uppercase' }}>
                Introdução ao curso 360º
              </p>
            </div>

            <div style={{ width: '84%', height: '500px', marginLeft: '10%' }}>
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/GP_1lWDVJ94?si=9e91UiBEu6OrTlD4"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="col-md-4 menu-home" style={{ backgroundColor: '#0E6B93', paddingTop: '40px', paddingLeft: '1rem' }}>
            {[
              {
                modulo: 1,
                titulo: 'Técnicas de manutenção preditiva',
                topicos: ['Alinhamento a laser', 'Termografia'],
              },
              {
                modulo: 2,
                titulo: 'Manutenção de equipamentos rotativos',
                topicos: ['Bombas', 'Compressores', 'Redutores'],
              },
              {
                modulo: 3,
                titulo: 'Dimensionamento de sistemas de elementos orgânicos de vedação',
                topicos: ['Gaxetas', 'Selos'],
              },
            ].map((mod, idx) => (
              <React.Fragment key={idx}>
                <p className="col-md-12 fontS-18" style={{ color: '#ffffff', marginBottom: '10px', marginTop: idx > 0 ? '30px' : 0 }}>
                  <strong>Módulo {mod.modulo}</strong> - {mod.titulo}
                </p>
                <div className="row" style={{ border: '2px solid #14A5E2', width: '95%', marginLeft: '2%', borderRadius: '12px', padding: '2%' }}>
                  <div className="col-md-2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ fontSize: '75px', color: '#ffffff', fontWeight: 700, marginBottom: 0 }}>{mod.modulo}</p>
                  </div>
                  <div className="col-md-9" style={{ marginTop: '9px' }}>
                    <ul style={{ listStyle: 'none', marginBottom: 0 }}>
                      {mod.topicos.map((topico, i) => (
                        <li
                          key={i}
                          className="btnHover"
                          style={{ padding: '3%', borderRadius: '8px', cursor: 'pointer', marginBottom: '5px' }}
                          onClick={handleClick}
                        >
                          {topico}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-md-1"></div>
                </div>
              </React.Fragment>
            ))}

            <div className="row" style={{ border: '2px solid #14A5E2', width: '95%', marginLeft: '2%', borderRadius: '12px', padding: '2%', marginTop: '30px' }}>
              <div className="col-md-2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src="./img/icon/icone-material-apoio.svg" alt="" />
              </div>
              <div className="col-md-9">
                <ul style={{ listStyle: 'none', marginBottom: 0 }}>
                  <li className="btnHover" style={{ padding: '3%', borderRadius: '8px', cursor: 'pointer', marginBottom: '5px' }}>
                    Material complementar
                  </li>
                </ul>
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default HomePage;